import { Injectable, inject } from '@angular/core';

import { filter } from 'rxjs';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { UserEvent, UserPreHooksLoginEvent } from '../user/user-events';
import { UserService } from '../user/user.service';
import { RegistrationInfoService } from './registration-info.service';

@Injectable()
export class RegistrationInfoBootstrapService implements OnAppInit {
    private readonly registrationInfoService = inject(RegistrationInfoService);
    private readonly userService = inject(UserService);

    onAppInit() {
        if (this.userService.isAuthenticated) {
            this.registrationInfoService.load();
        } else {
            this.userService.events
                .pipe(filter((event: UserEvent) => event instanceof UserPreHooksLoginEvent))
                .subscribe(() => this.registrationInfoService.load());
        }
    }
}
